import React from 'react';
import Footer from '../nav/footer';
import Menu from '../nav/menu';
import { useNavigate } from "react-router-dom";

 /* eslint-disable react/prop-types */
function NotFoundMobile(props) {
      const navigate = useNavigate();
      let pageText = "The Page you are looking is Not Found";
      let mainDivStyle = {
        position: "absolute",
        top: "85%", 
        left: "40%", 
        fontSize: "x-large", 
        color: "white"
    }

    if (props && props.message) {
        pageText = props.message;
    }
    return (
        <div>           
            <Menu></Menu>
            <div onClick={() => navigate("/")} style={{ backgroundColor: "#3B776D", display: "flex", justifyContent: "center", flexFlow: "column", position: "relative" }}>
                <div style={ mainDivStyle }>
                    <span>{pageText}</span>
                </div>
                 <img src='/img/defaultScreenMobile.jpg' alt=''/>
            </div>
            <Footer/>
        </div>
        
    )

}

export default NotFoundMobile;